const isProd = import.meta.env.MODE === 'production';

const env = {
  gtm: import.meta.env.VITE_GTM_ID ?? undefined,
  plausibleScriptUrl: import.meta.env.VITE_PLAUSIBLE_SCRIPT_URL ?? undefined,
  webUrl: import.meta.env.VITE_WEB_URL,
  appUrl: import.meta.env.VITE_APP_URL,
  authUrl: import.meta.env.VITE_AUTH_URL,
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  dev: !isProd,
};

export default env;
